import React from 'react';
import PropTypes from 'prop-types';
import {FranceActiveMap} from "./map";
import { regionFrance, guadeloupe, martinique, reunion } from "../utils/geojson";

export class FranceActive extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
        }
        this._allLayers = []
        this.clickOnRegion = this.clickOnRegion.bind(this)
        this.registerLayer = this.registerLayer.bind(this)
    }

    registerLayer(layer) {
        this._allLayers.push(layer)
    }

    UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.initialState && this.props.initialState !== nextProps.initialState) {
            if (this.props.handleSelection) {
                this._allLayers.forEach(registeredLayer => {
                    registeredLayer.resetStyle()
                })
            }
            this.setState({
                regionSelected: undefined
            })
        }
        if (this.props.regionSelected !== nextProps.regionSelected) {
            if (!(this.state.regionSelected && nextProps.regionSelected && this.state.regionSelected.id === nextProps.regionSelected.id)) {
                this._allLayers = []
                this.setState({
                    regionSelected: nextProps.regionSelected
                })
            }
        }
    }

    clickOnRegion(idRegion, regionName, layer) {
        this.setState({
            layerClicked: layer
        })
        if (this.props.clickOnRegion) {
            this.props.clickOnRegion(idRegion, regionName);
        }
    }

    render() {
        const areaType = `${this.props.prefixId || ''}-region`
        return (

                <div className={`france-maps${this.props.initialState ? '' : ' unvisible'} clickable-map`}>
                    
                    <div className="france-regions-map">
                        <FranceActiveMap idOnArea={true} areaType={areaType} layerClicked={this.state.layerClicked} showPopup={this.props.showPopup} highlightArea={this.props.highlightArea} {...regionFrance} clickOnRegion={this.clickOnRegion} registerLayer={this.registerLayer} withSelection={this.props.handleSelection}/>
                    </div>
                    <div className="dom-tom-maps">
                        <FranceActiveMap idOnArea={true} areaType={areaType} layerClicked={this.state.layerClicked} showPopup={this.props.showPopup} highlightArea={this.props.highlightArea} {...guadeloupe} clickOnRegion={this.clickOnRegion} registerLayer={this.registerLayer} withSelection={this.props.handleSelection}/>
                        <FranceActiveMap idOnArea={true} areaType={areaType} layerClicked={this.state.layerClicked} showPopup={this.props.showPopup} highlightArea={this.props.highlightArea} {...martinique} clickOnRegion={this.clickOnRegion} registerLayer={this.registerLayer} withSelection={this.props.handleSelection}/>
                        <FranceActiveMap idOnArea={true} areaType={areaType} layerClicked={this.state.layerClicked} showPopup={this.props.showPopup} highlightArea={this.props.highlightArea} {...reunion} clickOnRegion={this.clickOnRegion} registerLayer={this.registerLayer} withSelection={this.props.handleSelection}/>
                    </div>
                </div>


        )
    }
}

FranceActive.propTypes = {
    clickOnRegion: PropTypes.func,
    initialState: PropTypes.bool,
    handleSelection: PropTypes.bool,
    regionSelected: PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired
    })
}

FranceActive.defaultProps = {
    hasMoreContainer: true,
    initialState: true,
    handleSelection: true
}